import * as types from '../../constants/rmg/SportActionTypes'
import {env} from '../../constants/Environment';
import {url} from '../../constants/rmg/settings';
import _ from 'lodash';

export function load(){
	return async function(dispatch){
        dispatch({
            type: types.REQUEST
        });

        const response = await fetch(url + '/sports');
        const result = await response.json();

        dispatch({
            type: types.RECEIVE,
            data: result.sports
        })
    }
}